import { type Draft } from 'immer';

/**
 * Mutates the given array by removing duplicate items based on the given key.
 * The first item is kept, the later duplicates are removed.
 *
 * @param key property name to check for duplicates
 * @param array draft array to mutate recursively
 * @returns number of items removed from the array
 */
export default function migrateUniqueItemsByKey<T extends Draft<unknown>, K extends keyof T>(
  key: K,
  array: T[],
): number {
  const seen = new Set<T[K]>();
  let removedCount = 0;
  for (let index = 0; index < array.length; ) {
    const item = array[index];
    const id = item[key];
    if (seen.has(id)) {
      // Remove duplicate
      // NOTE: `index` remains the same for the next iteration
      array.splice(index, 1);
      removedCount += 1;
    } else {
      seen.add(id);
      index += 1;
    }
  }
  return removedCount;
}
